import { RibbonId } from './ribbonId';
import type { MailRibbonConfigStore } from '../store/schema/mailRibbonConfigStore';
import type { MailRibbonGroup } from '../store/schema/mailRibbonGroup';

function getRibbonSectionContents(groupId: RibbonId, controlIds: RibbonId[]): MailRibbonGroup {
    return {
        groupId,
        controlIds,
    };
}

// The default configuration for the SLR buttons
export const defaultConfig: MailRibbonConfigStore = {
    homeTab: [
        getRibbonSectionContents(RibbonId.Group_New, [
            RibbonId.ToggleLeftPane,
            RibbonId.NewMessage,
            RibbonId.DeleteItem,
            RibbonId.Archive,
            RibbonId.Sweep,
            RibbonId.Move,
            RibbonId.JunkFlyout,
            RibbonId.IgnoreStopIgnore,
            RibbonId.CreateRule,
        ]),
        getRibbonSectionContents(RibbonId.Group_Respond, [
            RibbonId.RespondReply,
            RibbonId.RespondReplyAll,
            RibbonId.RespondForward,
        ]),
        getRibbonSectionContents(RibbonId.Group_Tags, [
            RibbonId.ReadUnread,
            RibbonId.Categorize,
            RibbonId.FlagUnflag,
            RibbonId.PinUnpin,
            RibbonId.Snooze,
            RibbonId.AssignPolicy,
        ]),
        getRibbonSectionContents(RibbonId.Group_Undo, [RibbonId.Undo]),
        getRibbonSectionContents(RibbonId.Group_ImmersiveReader, [RibbonId.ImmersiveReader]),

        getRibbonSectionContents(RibbonId.Group_Print, [RibbonId.Print]),
    ],
    sendReceiveTab: [
        getRibbonSectionContents(RibbonId.Group_Send, [
            RibbonId.SendReceiveAllFolders,
            RibbonId.SendAll,
            RibbonId.UpdateFolder,
            RibbonId.SendReceiveGroups,
        ]),
        getRibbonSectionContents(RibbonId.Group_Sync, [
            RibbonId.SyncShowProgress,
            RibbonId.SyncCancelAll,
        ]),

        getRibbonSectionContents(RibbonId.Group_Offline, [RibbonId.OfflineWorkOffline]),

        getRibbonSectionContents(RibbonId.Group_Download, [RibbonId.DownloadDownloadHeaders]),
    ],
    messageTab: [
        getRibbonSectionContents(RibbonId.Group_Clipboard, [
            RibbonId.Paste,
            RibbonId.FormatPainter,
        ]),
        getRibbonSectionContents(RibbonId.Group_Names, [RibbonId.AddressBook, RibbonId.CheckNames]),
        getRibbonSectionContents(RibbonId.Group_Include, [
            RibbonId.AttachFile,
            RibbonId.AttachLink,
            RibbonId.AttachSig,
        ]),
        getRibbonSectionContents(RibbonId.Group_Sensitivity, [RibbonId.Sensitivity]),
        getRibbonSectionContents(RibbonId.Group_Tags, [
            RibbonId.HighImportance,
            RibbonId.LowImportance,
            RibbonId.FlagUnflag,
            RibbonId.AssignPolicy,
        ]),
        getRibbonSectionContents(RibbonId.Group_Voice, [RibbonId.Dictate]),
        getRibbonSectionContents(RibbonId.Group_ImmersiveReader, [RibbonId.ImmersiveReader]),
        getRibbonSectionContents(RibbonId.Group_Speech, [RibbonId.ReadAloud]),
        getRibbonSectionContents(RibbonId.Group_Encrypt, [RibbonId.Group_Encrypt]),
        getRibbonSectionContents(RibbonId.Group_Save, [RibbonId.Save]),
        getRibbonSectionContents(RibbonId.Group_PopoutDraft, [RibbonId.PopoutDraft]),
    ],
};
